export default {
  'company-global-settings-general': ['general_setting'],
  'company-information': ['company_information'],
  'company-bank': ['company_management_hide'],
  'company-invoice': ['company_management_hide'],
  'company-branch': ['company_management_hide'],
  'company-list-company': ['company_management_hide'],
  'company-integration': ['api_key_management'],
  'company-user-group-users': ['company_user_management'],
  'company-user-group-groups': ['company_group_management']
}
